import React from 'react';
import {FormattedMessage} from 'react-intl';
import {formattingPrice} from '../../_common/utils/format';
import {VAT} from '../../../../utils';
import moment from 'moment/moment';
import styles from './styles.module.scss';

const Calculation = ({
                       formikValues: {
                         commissionValueType,
                         commission: commissionLabel,
                         creditCardCommissionValueType,
                         creditCardCommission: creditCardCommissionLabel,
                         employerEducationFundValueType,
                         employerEducationFund: employerEducationFundLabel,
                         employerProvidentFundValueType,
                         employerProvidentFund: employerProvidentFundLabel,
                         employerMandatoryPensionValueType,
                         employerMandatoryPension: employerMandatoryPensionLabel,
                         compensationsValueType,
                         compensations: compensationsLabel,
                         employeeEducationFundValueType,
                         employeeEducationFund: employeeEducationFundLabel,
                         employeeProvidentFundValueType,
                         employeeProvidentFund: employeeProvidentFundLabel,
                         employeeMandatoryPensionValueType,
                         employeeMandatoryPension: employeeMandatoryPensionLabel,
                       },
                       amountWithVat,
                       expensesWithVat,
                       vat,
                       amountWithoutVat,
                       expensesWithoutVat,
                       exchangeFee,
                       creditCardCommission,
                       commission,
                       pensionManagementCommission,
                       employerCost,
                       compensations,
                       employerEducationFund,
                       employerMandatoryPension,
                       employerProvidentFund,
                       brutto,
                       accumulatedBrutto,
                       splitBrutto,
                       incomeTaxOffset,
                       employeeEducationFund,
                       employeeMandatoryPension,
                       employeeProvidentFund,
                       netto,
                       advancePayment,
                       nationalInsurance,
                       nationalInsuranceDebt,
                       supplierExpensesRefund,
                       expensesRefund,
                       toBePaid,
                       splits,
                       additionalCommission,
                       year,
                       month
                     }) => {
  const prefix = 'transfersByAgent-calculation';
  const yearValue = year?.value ? year?.value : moment().year();
  const monthValue = month?.value ? month?.value : moment().month() + 1;
  const date = new Date(yearValue, monthValue, 1);
  const Item = ({label, value, round = false}) => {
    const amount = value
      ?  round ? value.toString() : value.toFixed(2)
      : 0;
    return Boolean(amount) && (
      <div className={styles.summaryRow}>
        <span>{label}</span>
        {value && <span dir={'ltr'} className={`${value && value < 0 ? styles.neg : ''}`}>{formattingPrice(amount, true)}</span>}
      </div>
    );
  };

  return (
    <div className={styles.summaryTable}>
      <Item value={amountWithVat} label={<FormattedMessage id={`${prefix}-amount-with-vat`} defaultMessage={'Amount with VAT'}/>}/>
      <Item value={expensesWithVat} label={<FormattedMessage id={`${prefix}-expenses-with-vat`} defaultMessage={'Expenses with VAT'}/>}/>
      <Item value={vat} label={<FormattedMessage id={`${prefix}-vat`} defaultMessage={`VAT ({percent})`} values={{percent: `${VAT.percents(date)}%`}}/>}/>
      <Item value={amountWithoutVat} label={<FormattedMessage id={`${prefix}-w/o-vat`} defaultMessage={'Amount w/o VAT'}/>}/>
      <Item value={expensesWithoutVat} label={<FormattedMessage id={`${prefix}-expenses-w/o-vat`} defaultMessage={'Expenses w/o VAT'}/>}/>
      <Item value={exchangeFee} label={<FormattedMessage id={`${prefix}-exchange-fee`} defaultMessage={'Exchange fee'}/>}/>
      <Item
        value={creditCardCommission}
        label={
          <FormattedMessage
            id={`${prefix}-credit-card-commission`}
            defaultMessage={['Credit card commission', creditCardCommissionValueType.includes('percent') ? `(${creditCardCommissionLabel}%)` : ''].filter(Boolean).join(' ')}
            values={{creditCardCommission: creditCardCommissionValueType.includes('percent') ? `(${creditCardCommissionLabel}%)` : ''}}
          />
        }
      />
      <Item
        value={commission}
        label={
          <FormattedMessage
            id={`${prefix}-commission`}
            defaultMessage={['Commission', commissionValueType.includes('percent') ? `(${commissionLabel}%)` : ''].filter(Boolean).join(' ')}
            values={{commission: commissionValueType.includes('percent') ? `(${commissionLabel}%)` : ''}}
          />
        }
      />
      <Item value={additionalCommission} label={<FormattedMessage id={`${prefix}-additionalCommission`} defaultMessage={'Additional commission'}/>}/>
      <Item value={pensionManagementCommission} label={<FormattedMessage id={`${prefix}-pension-management`} defaultMessage={'Pension management'}/>}/>
      <Item value={employerCost} label={<FormattedMessage id={`${prefix}-employer-cost`} defaultMessage={'Employer cost'}/>}/>
      <Item
        value={compensations}
        label={
          <FormattedMessage
            id={`${prefix}-compensations`}
            defaultMessage={'Compensations'}
            values={{compensations: compensationsValueType.includes('percent') ? `(${compensationsLabel}%)` : ''}}
          />
        }
      />
      <Item
        value={employerEducationFund}
        label={
          <FormattedMessage
            id={`${prefix}-employer-education-fund`}
            defaultMessage={'Employer education fund'}
            values={{employerEducationFund: employerEducationFundValueType.includes('percent') ? `(${employerEducationFundLabel}%)` : ''}}
          />
        }
      />
      <Item
        value={employerMandatoryPension}
        label={
          <FormattedMessage
            id={`${prefix}-employer-mandatory-pension`}
            defaultMessage={'Employer mandatory pension'}
            values={{employerMandatoryPension: employerMandatoryPensionValueType.includes('percent') ? `(${employerMandatoryPensionLabel}%)` : ''}}
          />
        }
      />
      <Item
        value={employerProvidentFund}
        label={
          <FormattedMessage
            id={`${prefix}-employer-provident-fund`}
            defaultMessage={'Employer provident fund'}
            values={{employerProvidentFund: employerProvidentFundValueType.includes('percent') ? `(${employerProvidentFundLabel}%)` : ''}}
          />
        }
      />
      <Item value={brutto} label={<FormattedMessage id={`${prefix}-brutto`} defaultMessage={'Brutto'}/>}/>
      <Item value={accumulatedBrutto} label={<FormattedMessage id={`${prefix}-accumulated-brutto`} defaultMessage={'Accumulated brutto'}/>}/>
      <Item
        value={splitBrutto}
        label={
          <FormattedMessage
            id={`${prefix}-split-brutto`}
            defaultMessage={'Split brutto (1/{splits})'}
            values={{splits}}
          />
        }
      />
      <Item value={incomeTaxOffset} label={<FormattedMessage id={`${prefix}-income-tax`} defaultMessage={'Income tax'}/>}/>
      <Item
        value={employeeEducationFund}
        label={
          <FormattedMessage
            id={`${prefix}-employee-education-fund`}
            defaultMessage={'Employee education fund'}
            values={{employeeEducationFund: employeeEducationFundValueType.includes('percent') ? `(${employeeEducationFundLabel}%)` : ''}}
          />
        }
      />
      <Item
        value={employeeMandatoryPension}
        label={
          <FormattedMessage
            id={`${prefix}-employee-mandatory-pension`}
            defaultMessage={'Employee mandatory pension'}
            values={{employeeMandatoryPension: employeeMandatoryPensionValueType.includes('percent') ? `(${employeeMandatoryPensionLabel}%)` : ''}}
          />
        }
      />
      <Item
        value={employeeProvidentFund}
        label={
          <FormattedMessage
            id={`${prefix}-employee-provident-fund`}
            defaultMessage={'Employee provident fund'}
            values={{employeeProvidentFund: employeeProvidentFundValueType.includes('percent') ? `(${employeeProvidentFundLabel}%)` : ''}}
          />
        }
      />
      <Item value={netto} label={<FormattedMessage id={`${prefix}-netto`} defaultMessage={'Netto'}/>}/>
      <Item value={advancePayment} label={<FormattedMessage id={`${prefix}-advance-payment`} defaultMessage={'Advance payment'}/>}/>
      <Item value={nationalInsurance} label={<FormattedMessage id={`${prefix}-national-insurance`} defaultMessage={'National insurance'}/>}/>
      <Item value={nationalInsuranceDebt} label={<FormattedMessage id={`${prefix}-national-insurance-debt`} defaultMessage={'National insurance debt'}/>}/>
      <Item value={supplierExpensesRefund} label={<FormattedMessage id={`${prefix}-supplier-expenses-refund`} defaultMessage={'Supplier expenses refund'}/>}/>
      <Item value={expensesRefund} label={<FormattedMessage id={`${prefix}-expenses-refund`} defaultMessage={'Expenses refund'}/>}/>
      <Item value={toBePaid} label={<FormattedMessage id={`${prefix}-to-be-paid`} defaultMessage={'To be paid'}/>} round={true}/>
    </div>
  );
};

export default Calculation;